import { cva } from 'class-variance-authority'

export const horizontalCarouselButtonVariants = cva(
  [
    'absolute z-10 hidden items-center justify-center disabled:hidden sm:flex',
    '-translate-y-1/2 rounded-full transition duration-300 size-12 top-1/2',
  ],
  {
    variants: {
      type: {
        prev: 'left-0',
        next: 'right-0',
      },
      position: {
        inside: '',
        border: '',
      },
    },
    compoundVariants: [
      // inside
      {
        type: 'prev',
        position: 'inside',
        class: '-translate-x-0',
      },
      {
        type: 'prev',
        position: 'inside',
        class: 'translate-x-0',
      },

      // border
      {
        type: 'prev',
        position: 'border',
        class: '!-translate-x-1/2',
      },
      {
        type: 'next',
        position: 'border',
        class: 'translate-x-1/2',
      },
    ],
  }
)

export const verticalCarouselButtonVariants = cva(
  'absolute z-10 items-center justify-center flex disabled:hidden inset-x-1/2 -translate-x-1/2 size-9',
  {
    variants: {
      type: {
        prev: 'top-0',
        next: 'bottom-0',
      },
      position: {
        inside: 'translate-y-0',
        border: 'translate-y-1/2',
      },
    },
    compoundVariants: [
      {
        type: 'prev',
        position: 'inside',
        class: 'top-0 -translate-y-0',
      },
      {
        type: 'prev',
        position: 'border',
        class: 'top-0 -translate-y-1/2',
      },
    ],
  }
)
